import { RailDocument, NewDocument } from "shared/models/api/models"
import { Document } from "shared/models/site/document"
import { RulebookModeEnum } from "../../enums/rulebook-mode-enum";

export const toISOLocalDate = (date?: any): string | undefined => {
    if (!date) return undefined;
    const z = (n: any) => (`0${ n }`).slice(-2);
    const d = new Date(date);
    return `${ d.getFullYear() }-${ z(d.getMonth() + 1) }-${ z(d.getDate()) }`;
}

export const formatTime = (date?: any) =>
    date ?
        new Date(date).toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
        : undefined;

export const formatDateTime = (date?: any) => {
    if (!date) {
        return '';
    }
    if (typeof (date) === 'string') {
        date = new Date(date);
    }
    return `${ date.toLocaleDateString("en-AU") } ${ formatTime(date) }`;
}

export const formatDate = (date?: any) => {
    if (!date) {
        return '';
    }
    if (typeof (date) === 'string') {
        date = new Date(date);
    }
    return date.toLocaleDateString("en-AU");
}

export const isoDateStringToBrowserSafeString = (dateString: string) => {
    //Safari isn't happy with ISO string, this format looks to work on Chromium and Safari
    var date = dateString.replace(/-/g, '/').replace('T', ' ');
    return date
}

export const dateToBrowserSafeString = (date: Date) => {
    return isoDateStringToBrowserSafeString(date.toISOString());
}

export const toLocalDateTimeFields = (obj: any, fields: Array<string>): any => {
    fields.forEach(x => {
        if (typeof obj[x] === 'string') {
            obj[x] = isoDateStringToBrowserSafeString(`${ toISOLocalDate(obj[x]) } ${ formatTime(obj[x]) }`);
        }
    });
    return obj;
}

export const documentMapper = {
    mapFromRailDocument: (railDocument: RailDocument): Document => {
        const effectiveFromDate = railDocument.effectiveFromDate < railDocument.publishDate
            ? railDocument.publishDate
            : railDocument.effectiveFromDate;
        const val = {
            documentId: railDocument.id,
            documentModule: railDocument.moduleId,
            typeLabel: railDocument.type,
            typeId: railDocument.typeId,
            subTypeId: railDocument.subTypeId,
            subTypeLabel: railDocument.subType,
            title: railDocument.title,
            documentNumber: railDocument.documentNumber,
            versionNumber: railDocument.version,
            effectiveFromDate: toISOLocalDate(effectiveFromDate),
            effectiveFromTime: formatTime(effectiveFromDate),
            expiryDate: toISOLocalDate(railDocument.expiryDate),
            expiryTime: formatTime(railDocument.expiryDate),
            publishDate: toISOLocalDate(railDocument.publishDate),
            publishTime: formatTime(railDocument.publishDate),
            requiresAcknowledgementAndNotify: railDocument.requiresAcknowledgementAndNotify,
            releaseNotes: railDocument.releaseNotes,
            rescindDocumentReason: railDocument.rescindDocumentReason,
            fileName: railDocument.fileName,
            reviewPeriod: railDocument.reviewPeriod,
            reviewRecurring: railDocument.reviewRecurring,
            relatedDocuments: (railDocument.relatesTo || []).map(x => ({ id: x.key, title: x.value })),
            canEdit: railDocument.canEdit,
            acknowledgeRequired: railDocument.acknowledgeRequired,
            departments: railDocument.departments,
            departmentNames: railDocument.departments?.map(d => d.name),
            department: railDocument.department,
            departmentTeams: railDocument.documentTeams?.map(t => t.team),
            personnelId: railDocument.documentUsers?.map(n => n.id),
            personnel: railDocument.documentUsers,
            rulebookOperatingSystem:
                railDocument.traditional ? RulebookModeEnum.Traditional : railDocument.cbtc ? RulebookModeEnum.CBTC :
                    railDocument.traditional && railDocument.cbtc ? RulebookModeEnum.Both : RulebookModeEnum.Traditional 
        } as Document;
        return val;
    },
    mapToNewDocument: (document: Document): NewDocument => {
        console.log('Mapping to new document');
        const val = {
            documentModule: document.documentModule,
            documentType: document.subTypeId ? document.subTypeId : document.typeId,
            title: document.title,
            documentNumber: document.documentNumber,
            versionNumber: document.versionNumber,
            effectiveFrom: dateToBrowserSafeString(new Date(isoDateStringToBrowserSafeString(`${ document.effectiveFromDate } ${ document.effectiveFromTime || '00:00' }`))),
            expiryDate: document.expiryDate
                ? dateToBrowserSafeString(new Date(isoDateStringToBrowserSafeString(`${ document.expiryDate } ${ document.expiryTime || '00:00' }`)))
                : undefined,
            reviewPeriod: document.reviewPeriod,
            reviewRecurring: document.reviewRecurring,
            requiresAcknowledgementAndNotify: document.requiresAcknowledgementAndNotify || false,
            releaseNotes: document.releaseNotes,
            rescindDocumentReason: document.rescindDocumentReason,
            file: document.file,
            relatesTo: document.relatedDocuments?.map(x => x.id),
            rulebookOperatingSystem: document.rulebookOperatingSystem,
            departments: document.departments?.map(d => d.id),
            departmentTeams: document.departmentTeams,
            PersonnelId: document.personnelId
        } as NewDocument;

        return val;
    }
}
